/* eslint-disable @typescript-eslint/no-unused-vars */

import "amazon-connect-streams";
import { createContext } from "react";
import { IAgent, ICall, IQueue, IPhoneDirItem } from "../interfaces";
/**
 * Provides shared features to the app
 */
export interface IConnectDataContext {
    agents: IAgent[];
    callLog: ICall[];
    queues: IQueue[];
    phoneDirectoryItems: IPhoneDirItem[];
    setDirectorySearchTerm: (str: string) => void;
    setSelectedQueueName: (str: string) => void;
    availableDispositions: string[];
    showDispositions: boolean;
    currentQueueName: string;
    selectedQueueName: string;
    contactId: string;
    availableAgentEndpoints: connect.Endpoint[];
    availableQueueEndpoints: connect.Endpoint[];
}

const ConnectDataContext = createContext<IConnectDataContext>(null as any);

ConnectDataContext.displayName = "ConnectConfigDataContext"; // used in dev tools
export { ConnectDataContext };
